import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLayout } from "../../layout/core";
import { toAbsoluteUrl } from "../../helpers";
import TopRightTools from "./top-right/TopRightTools";
import HeaderContents from "./HeaderContents";
import SuperAdminTopRightTools from "./top-right/SuperAdminTopRightTools";
import { IconButton, useMediaQuery, useTheme, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ReactModal from "react-modal";
import SaveModal from "./top-right/SaveModal";
import { useGetAllTeamsByIdQuery } from "../../Services/email/EmailTemplate";
import { CIRCLEONE_TEAM } from "../../constants";
import { useTeamsQuery } from "../../Services/settingsAPIs/CommonAPI";

interface HeaderWrapperProps {
  onMobileMenuToggle?: () => void;
}

const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
  onMobileMenuToggle,
}) => {
  const { config, classes, attributes } = useLayout();
  const { header, aside } = config;
  const theme = useTheme();
  const [selectedTeam, setSelectedTeam] = useState<any>([]);
  const teamName = localStorage.getItem(CIRCLEONE_TEAM);
  const [selectedTeamId, setSelectedTeamId] = useState<string>(teamName || "");
  const [isSaveModalOpen, setIsSaveModalOpen] = useState<boolean>(false);
  const isMobile = useMediaQuery("(max-width:991px)");
  const isSuperAdminLoggedIn = localStorage.getItem("super-user");
  const planName = localStorage.getItem("planName") || "Standard";
  const planDisplayName = `${planName} Plan`;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 520);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 520);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const { data: teams } = useTeamsQuery({});
  const { data: getTeamsById } = useGetAllTeamsByIdQuery(
    localStorage.getItem("User_Id")
  );

  const teamChange = (team: any) => {
    setSelectedTeam(team);
    setSelectedTeamId(team.name);
    openSaveModal();
  };

  const handleTeamSelectChange = (event: any) => {
    const selectedTeamName = event.target.value;
    setSelectedTeamId(selectedTeamName);
    
    // Find the team object from the teams array
    const teamArray = getTeamsById?.role === "admin" ? teams : getTeamsById?.teams;
    const selectedTeamObj = teamArray?.find((team: any) => team.name === selectedTeamName);
    
    if (selectedTeamObj) {
      teamChange(selectedTeamObj);
    }
  };

  // Prepare team options for Select
  const getTeamOptions = () => {
    const teamArray = getTeamsById?.role === "admin" ? teams : getTeamsById?.teams;
    return teamArray
      ?.slice()
      .sort((a: any, b: any) => a.name.localeCompare(b.name))
      .map((team: any) => ({
        value: team.name,
        label: team.name,
      })) || [];
  };

  const openSaveModal = () => {
    setIsSaveModalOpen(true);
  };

  const closeSaveModal = () => {
    setIsSaveModalOpen(false);
  };

  const afterOpenSaveModal = () => {
    // Any logic to run after modal opens
  };

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      zIndex: 9999,
      padding: '0',
    },
    overlay: {
      zIndex: 9998,
    },
  };
  return (
    <>
      {/* Desktop Header - Only render on desktop */}
      {!isMobile && (
        <div
          id="kt_header"
          className="header align-items-stretch justify-content-between"
          style={{
            left: 0,
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
            <div
              className="app-header-menu app-header-mobile-drawer ms-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Link to="/dashboard/email-dashboard">
                <img
                  alt="Logo"
                  src={toAbsoluteUrl(
                    "/media/logos/CircleOne-Logo-With-Change.png"
                  )}
                  className="h-60px"
                />
              </Link>

              <p
                className="d-flex align-items-center mx-2"
                style={{
                  fontSize: "20px",
                  margin: 0,
                }}
              >
                CircleOne CRM
              </p>
              <Link
                to="/user-profile"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  alignSelf: "center",
                  gap: "6px",
                  padding: "4px 12px",
                  borderRadius: "10px",
                  background: "#e0e7ff",
                  border: "1px solid #a5b4fc",
                  color: "#6366f1",
                  fontSize: "13px",
                  fontWeight: 600,
                  lineHeight: 1,
                  height: "35px",
                  cursor: "pointer",
                  textDecoration: "none",
                  marginInline: "10px",
                }}
              >
                {planDisplayName}
              </Link>

              {isDesktop && (
                <div className="ms-3">
                  <FormControl fullWidth style={{ minWidth: 150 }}>
                    <Select
                      labelId="team-select-label"
                      id="team-select"
                      value={selectedTeamId}
                      onChange={handleTeamSelectChange}
                      sx={{
                        backgroundColor: '#f3f4f6',
                        borderRadius: '10px',
                        height: '37.5px',
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: '1px solid #d1d5db'
                        }
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflowY: 'auto'
                          }
                        }
                      }}
                      renderValue={(value) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <i className="bi bi-people fs-4 me-2" style={{color:"#374151"}}></i>
                          {value}
                        </div>
                      )}
                    >
                      {getTeamOptions().map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}

            </div>

            {!isSuperAdminLoggedIn ? (
              <div className="d-flex align-items-stretch flex-shrink-0 mx-5">
                <TopRightTools />
              </div>
            ) : (
              <div className="d-flex align-items-stretch flex-shrink-0 mx-5">
                <SuperAdminTopRightTools />
              </div>
            )}
          </div>
        </div>
      )}

      {/* Mobile Header - Only render on mobile */}
      {isMobile && (
        <div
          style={{
            padding: "6px 10px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            height: "60px",
            gap: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Menu Icon */}
          <IconButton
            onClick={onMobileMenuToggle}
            sx={{
              padding: "6px",
              flexShrink: 0,
            }}
          >
            <MenuIcon fontSize="medium" />
          </IconButton>

          {/* Logo */}
          <Link
            to="/dashboard/email-dashboard"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              flexShrink: 0,
            }}
          >
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/CircleOne-Logo-With-Change.png")}
              style={{ height: "32px" }}
            />
          </Link>

          {/* Title - Hidden on very small screens */}
          <span
            className="mobile-header-title"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#000",
              whiteSpace: "nowrap",
            }}
          >
            CircleOne CRM
          </span>

          {isDesktop && (
            <div className="ms-2">
              <FormControl fullWidth style={{ minWidth: 150 }}>
                <Select
                  labelId="mobile-team-select-label"
                  id="mobile-team-select"
                  value={selectedTeamId}
                  onChange={handleTeamSelectChange}
                  size="small"
                  sx={{
                    backgroundColor: '#f3f4f6',
                    borderRadius: '10px',
                    height: '37.5px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #d1d5db'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflowY: 'auto'
                      }
                    }
                  }}
                  renderValue={(value) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-people fs-4 me-2" style={{color:"#374151"}}></i>
                      {value}
                    </div>
                  )}
                >
                  {getTeamOptions().map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}

          {/* Spacer */}
          <div style={{ flex: 1, minWidth: "8px" }}></div>

          {/* Right Tools - Compact for mobile */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              gap: "2px",
            }}
          >
            {!isSuperAdminLoggedIn ? (
              <TopRightTools />
            ) : (
              <SuperAdminTopRightTools />
            )}
          </div>
        </div>
      )}

      {/* Additional CSS for mobile responsive icons */}
      <style>{`
        @media (max-width: 991px) {
          /* Make icons smaller on mobile */
          .MuiIconButton-root {
            padding: 4px !important;
          }
          
          /* Reduce font sizes in mobile header tools */
          .dropdown-toggle {
            font-size: 12px !important;
            padding: 4px 8px !important;
          }
          
          /* Ensure all icons are visible */
          .btn-icon {
            width: 32px !important;
            height: 32px !important;
          }
        }

        @media (max-width: 576px) {
          /* Further reduce on very small screens */
          img[alt="Logo"] {
            height: 28px !important;
          }
          
          .MuiIconButton-root svg {
            font-size: 20px !important;
          }
        }

        @media (max-width: 600px) {
          /* Hide CircleOne CRM text on screens smaller than 660px */
          .mobile-header-title {
            display: none !important;
          }
        }
      `}</style>

      <ReactModal
        isOpen={isSaveModalOpen}
        onAfterOpen={afterOpenSaveModal}
        onRequestClose={closeSaveModal}
        style={customModalStyles}
        contentLabel="Save"
        shouldCloseOnOverlayClick={false}
      >
        <SaveModal
          closeSaveModal={closeSaveModal}
          selectedTeam={selectedTeam}
        />
      </ReactModal>
    </>
  );
};

export default HeaderWrapper;
